import { render, staticRenderFns } from "./display-results.vue?vue&type=template&id=7851a769&scoped=true"
import script from "./display-results.vue?vue&type=script&lang=js"
export * from "./display-results.vue?vue&type=script&lang=js"
import style0 from "./display-results.vue?vue&type=style&index=0&id=7851a769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7851a769",
  null
  
)

export default component.exports